// const loadModules = () => {


	require("default/js/shared/voyadoAnalyticsLoader");
	require("default/js/shared/ui");
	require("default/js/shared/messagesMgr");
	require("default/js/shared/integrationRegistrar");
	require("default/js/shared/featureFlagRegistrar");
	require("default/js/shared/empty");
	require("default/js/shared/customerSections");
	require("default/js/shared/checkoutAdapter");
	require("default/js/shared/analytics");
	require("default/js/shared/ui/siteMenuContext");
	require("default/js/shared/translate/storage");
	require("default/js/shared/resolvers/resolveJquery");
	require("default/js/shared/integration/voyado");
	require("default/js/shared/integration/eventDispatcher");
	require("default/js/shared/integration/voyado/eventProvider");
	require("default/js/shared/integration/eventDispatcher/provider");
	require("default/js/shared/integration/eventDispatcher/plugin");
	require("default/js/shared/integration/eventDispatcher/dispatcher");
	require("default/js/shared/featureFlag/provider");
	require("default/js/shared/customerSections/traverseToSetItems");
	require("default/js/shared/customerSections/transformXmlResponseToJson");
	require("default/js/shared/customerSections/timestampResolver");
	require("default/js/shared/customerSections/resolveOverrides");
	require("default/js/shared/customerSections/invalidationStateVerifier");
	require("default/js/shared/customerSections/extractMetaDataFields");
	require("default/js/shared/customerSections/dbNameResolver");
	require("default/js/shared/customerSections/customerSectionsLockable");
	require("default/js/shared/customerSections/alpineAccessor");
	require("default/js/shared/consent/resolver");
	require("default/js/shared/components/messagesToastr");
	require("default/js/shared/components/messagesConst");
	require("default/js/shared/components/messagesBusEndpoint");
	require("default/js/shared/components/messagesBus");
	require("default/js/shared/components/messagesAjaxErrorTrigger");
	require("default/js/shared/components/messages");
	require("default/js/shared/components/messagesProcessor/genericToastr");
	require("default/js/shared/components/messagesProcessor/ajaxErrorToastr");
	require("default/js/shared/components/messagesBus/messageBusJqueryAjax");
	require("default/js/shared/components/messagesBus/messageBusCookieMessage");
	require("default/js/shared/analytics/voyado");
	require("default/js/shared/analytics/voyado/pageEvents");
	require("default/js/shared/gamifiera/eventProvider");
	require("default/js/shared/promotionWidget");
	require("default/js/shared/component/promotionWidget/widget");
	require("default/js/shared/component/promotionWidget/client_v1");
	require("default/js/shared/component/promotionWidget/client");
	require("default/js/shared/component/cart/updateCartWithPromo");
	require("default/js/shared/klarnaUpsellWidget");
	require("default/js/shared/component/klarnaUpsellWidget/widgetStrategy");
	require("default/js/shared/component/klarnaUpsellWidget/widget");
	require("default/js/shared/component/klarnaUpsellWidget/client");
	require("default/js/shared/component/klarnaUpsellWidget/widget/legacyType");
	require("default/js/shared/component/klarnaUpsellWidget/widget/bySlotType");
	require("default/js/shared/component/klarnaUpsellWidget/component/timerInjector");
	require("default/js/shared/component/klarnaUpsellWidget/component/timer");
	require("default/js/shared/component/klarnaUpsellWidget/component/slider");
	require("default/js/shared/component/klarnaUpsellWidget/component/legacySceneSwitcher");
	require("default/js/shared/component/klarnaUpsellWidget/component/addToOrderInjector");
	require("default/js/shared/xml2json");
	require("default/js/shared/url");
	require("default/js/shared/underscore");
	require("default/js/shared/lazysizes");
	require("default/js/shared/http");
	require("default/js/shared/embla");
	require("default/js/shared/dom");
	require("default/js/shared/dev-mode");
	require("default/js/shared/alpinejs");
	require("default/js/shared/util/observable");
	require("default/js/shared/util/cookies-operation");
	require("default/js/shared/util/cookies-observer");
	require("default/js/shared/underscore/string");
	require("default/js/shared/underscore/objects");
	require("default/js/shared/underscore/lib");
	require("default/js/shared/lazysizes/dynamic");
	require("default/js/shared/embla/embla-carousel.min");
	require("default/js/shared/alpinejs/ui");
	require("default/js/shared/alpinejs/tracker");
	require("default/js/shared/alpinejs/toolkit");
	require("default/js/shared/alpinejs/persist");
	require("default/js/shared/alpinejs/parent");
	require("default/js/shared/alpinejs/lib");
	require("default/js/shared/alpinejs/lib-ext");
	require("default/js/shared/alpinejs/focus");

 // }
// document.addEventListener('DOMContentLoaded', loadModules);
document.dispatchEvent(new CustomEvent('custom:shared-components-loaded'));
